import "../AppHeader.scss";
import type { FC } from "react";
import AppMenu from "../../AppMenu/AppMenu";
import AppSettings from "../../AppSettings/AppSettings";
import { useAppStyling } from "../../WhiteLabel/useAppStyling";
import {
  AppMainHeader,
  AppHeaderLogoAndMainNav,
  AppHeaderSecondaryNav,
} from "@SeemplicityDev/shared";
import { capitalize } from "lodash-es";

const ClassicAppHeader: FC = () => {
  const { appProps } = useAppStyling();
  return (
    <AppMainHeader className="seem-app-header">
      <AppHeaderLogoAndMainNav
        logos={[
          {
            src: appProps?.logo?.app,
            label: capitalize(appProps?.orgName),
          },
        ]}
      >
        <AppMenu />
      </AppHeaderLogoAndMainNav>
      <AppHeaderSecondaryNav>
        <AppSettings />
      </AppHeaderSecondaryNav>
    </AppMainHeader>
  );
};

export default ClassicAppHeader;
